export default __webpack_public_path__ + "static/bg-mast-head-ca0ad68ae033c29868ae77e5a597b8f3.svg";